module.exports = __webpack_public_path__ + "img/hover_icon_egreso.9011091a.svg";